<div class="container">
    <lib-generic-dropdown
        name="subDivision"
        id="subDivision"
        [(selectedItem)]="selectedDepartment"
        (selectedItemChange)="onDepartmentChange()"
        [source]="departments"
        [config]="{
            defaultText: 'Select ' + label,
            itemDisplayKey: 'name',
            isActive: selectedDepartment?.isActive ?? true,
            clearSelection: selectedDepartment?.id ? true : false
        }"
        [isReadOnly]="isReadOnly"
        [error]="!isValid"
    >
        ></lib-generic-dropdown
    >
    <app-validation-error-message [show]="!isValid" [errors]="validationErrors"></app-validation-error-message>
</div>
